import {prefixPath} from "@pg-mono/prefix-path";

export const storeApiPath = prefixPath("/ms/v1/", {
    store: prefixPath("store/", {
        base: "",
        userPreferences: "user-preferences/",
        semanticSearch: "semantic-search/"
    })
});

export const storeApiLink = {
    store: {
        base: storeApiPath.store.base,
        userPreferences: storeApiPath.store.userPreferences,
        semanticSearch: storeApiPath.store.semanticSearch
    }
};

// User preferences
export const userPreferencesRouterApiPath = prefixPath("/user-preferences", {
    base: ""
});

export const userPreferencesRouterApiLink = {
    userPreferences: userPreferencesRouterApiPath.base
};

export const userPreferencesApiLink = {
    userPreferences: {
        base: createLink(storeApiPath.store.userPreferences)
    }
};

// Semantic search
export const semanticSearchRouterApiPath = prefixPath("/semantic-search", {
    base: ""
});

export const semanticSearchRouterApiLink = {
    semanticSearch: semanticSearchRouterApiPath.base
};

export const semanticSearchApiLink = {
    semanticSearch: {
        base: createLink(storeApiPath.store.semanticSearch)
    }
};

// Utils
function createLink(apiPathElement: string): (microserviceApiUrl: string | null) => string {
    return (microserviceApiUrl: string | null) => {
        // by default store microservice should use relative path with optional absolute path
        return `${microserviceApiUrl ?? ""}${apiPathElement}`;
    };
}
import {prefixPath} from "@pg-mono/prefix-path";

export const storeApiPath = prefixPath("/ms/v1/", {
    store: prefixPath("store/", {
        base: "",
        userPreferences: "user-preferences/",
        semanticSearch: "semantic-search/"
    })
});

export const storeApiLink = {
    store: {
        base: storeApiPath.store.base,
        userPreferences: storeApiPath.store.userPreferences,
        semanticSearch: storeApiPath.store.semanticSearch
    }
};

// User preferences
export const userPreferencesRouterApiPath = prefixPath("/user-preferences", {
    base: ""
});

export const userPreferencesRouterApiLink = {
    userPreferences: userPreferencesRouterApiPath.base
};

export const userPreferencesApiLink = {
    userPreferences: {
        base: createLink(storeApiPath.store.userPreferences)
    }
};

// Semantic search
export const semanticSearchRouterApiPath = prefixPath("/semantic-search", {
    base: ""
});

export const semanticSearchRouterApiLink = {
    semanticSearch: semanticSearchRouterApiPath.base
};

export const semanticSearchApiLink = {
    semanticSearch: {
        base: createLink(storeApiPath.store.semanticSearch)
    }
};

// Utils
function createLink(apiPathElement: string): (microserviceApiUrl: string | null) => string {
    return (microserviceApiUrl: string | null) => {
        // by default store microservice should use relative path with optional absolute path
        return `${microserviceApiUrl ?? ""}${apiPathElement}`;
    };
}
